module.exports = __webpack_public_path__ + "img/list1.20d94468.png";